import React from "react"

export default function Resume(){
    const [currentComponent, setCurrentComponent] = React.useState()
    const [containerClass, setContainerClass] = React.useState("resume-container")
    const [experienceComponent, setExperienceComponent] = React.useState()
    const [innerContainerClass, setInnerContainerClass] = React.useState("work-info fade-in")
    const [showExperienceComponent, setShowExperienceComponent] = React.useState(false)
    const [delayTimer, setDelayTimer] = React.useState(500)
    
    function handleClick(component, cssClass) {        
        setContainerClass(cssClass+" fade-out")
        setTimeout(() => {
          setShowExperienceComponent(false)
          setCurrentComponent(component)
          setContainerClass(cssClass+" fade-in")
        }, delayTimer)
    }

    function handleExperienceButtons(jobNum) {
        if (showExperienceComponent){
            setInnerContainerClass("work-info fade-out")
            setTimeout(() => {
                getExperienceComponent(jobNum)
                setInnerContainerClass("work-info fade-in")
                console.log("ran timer")
            }, delayTimer)
        } else {
            getExperienceComponent(jobNum)
            setShowExperienceComponent(true)
        }
    }

    function getExperienceComponent(jobNum) {
        switch(jobNum) {
            case 0:
                setExperienceComponent(() => {
                    return (
                        <div className={innerContainerClass}>
                            <h2>IT Support Specialist</h2>
                            <p><i>Prescient Co.</i> • Contract • May 2022 - Present</p>
                            <ul>
                                <li>Track and respond to internal technical issues using ZenDesk ticketing system</li>
                                <li>Created and maintain inventory system using proprietary application developed in house using Python, Microsoft Excel, and Power BI</li>
                                <li>Refactor and maintain system automation scripts using Powershell and Python</li>
                                <li>Support internal clients using remote solutions such as Dameware, Chrome Remote Desktop, MS Teams, and other VNC clients</li>
                                <li>Diagnose and repair complex software and hardware issues with client endpoints, internal servers, and remote servers in a datacenter environment</li> 
                                <li>Support Windows Desktop, Mac OS (iPad and Macbooks), and Windows Server environments using Active Directory, Verizon MDM, HP Device Manager and other System Administration Tools</li>
                            </ul>
                        </div>
                    )
                })                    
                break;
            case 1:
                setExperienceComponent(() => {
                    return (
                        <div className={innerContainerClass}>
                            <h2>Web Developer</h2>
                            <p><i>Channel One Regional Food Bank</i> • Contract • Apr 2022 - Present</p>
                            <ul>
                                <li>Collect information and create content using several plug-ins/tools such as Gravity Forms, Content Blocks, Popup Maker, and Google Analytics</li>
                                <li>Create and maintain custom plug-ins using PHP and REST APIs to solve specific business problems related to the food bank</li>
                                <li>Create custom monthly analytics reports using Google Analytics and AIOSEO</li>
                                <li>Maintain and create system automation rules using Zapier for connecting tools such as Bloomerang, Stripe, and Wordpress together</li>
                                <li>Create new web pages using HTML5, CSS3, PHP, and Javascript to display new content for the food banks as needed</li>
                            </ul>
                        </div>
                    )
                })
                break;
            case 2:
                setExperienceComponent(() => {
                    return (
                        <div className={innerContainerClass}>
                            <h2>Web Developer</h2>
                            <p><i>ITGuysTeam</i> • Contract • Sep 2021 - Feb 2022</p>
                            <ul>
                                <li>Wrote Knowledge Base Articles for training new hires and maintain other documentation to keep information up-to-date</li>
                                <li>Built training web app for new hires to use as a call script during client support calls</li>
                                <li>Designed and launched new websites for customers and clients using CMS technologies along with HTML, CSS, Javascript, and React.js</li>
                                <li>Performed internal SEO to up rankings in SERPs and generate better conversions</li>
                                <li>Debugged internal website, MySQL Databases, and client websites as requested by development lead and required by clients</li>
                                <li>Maintained great teamwork and organization through agile methodologies using tools such as Slack (Scrum), Kanban, and Trello</li>
                            </ul>
                        </div>
                    )
                })
                break;
            case 3:
                setExperienceComponent(() => {
                    return (
                        <div className={innerContainerClass}>
                            <h2>IT Support Specialist - Team Lead</h2>
                            <p><i>Sunrun</i> • FTE • Aug 2020 - Jul 2021</p>
                            <ul>
                                <li>Managed 27 team members and associates to provide excellent customer service to internal clients</li>
                                <li>Consistently praised for high quality work, customer-oriented attitude, and persistence to get issues resolved quickly and reliably. </li>
                                <li>Communicated with other departments and teams frequently in a friendly, supportive manner to efficiently resolve customer issues</li>
                                <li>Supported iOS, Chrome OS (chromebook), and Windows Operating Systems for maintaining optimal working environment</li>
                                <li>Supported internal clients through Google Chat (Google Suite, G Suite) environments</li>
                                <li>Managed Chromebook and iPad devices through remote MDM tools and system administration services</li>
                                <li>Resolved complex software and hardware installations and troubleshooting in an IT Help Desk environment</li>
                            </ul>
                        </div>
                    )
                })
                break;
            case 4:
                setExperienceComponent(() => {
                    return (
                        <div className={innerContainerClass}>
                            <h2>Hardware Engineer</h2>
                            <p><i>GameWorks</i> • FTE • Apr 2019 - Jul 2020</p>
                            <ul>
                                <li>Assembled, disassembled, and tested electronic and mechanical equipment and parts; to inspect, identify, troubleshoot,refurbish and/or repair electronic-mechanical equipment.</li>
                                <li>Accurately evaluated electronic products and equipment down to the board component level.</li>
                                <li>Followed written procedures and processes but also have the ability to think quickly to answer questions and solve problems involving differing situations, requiring creativity to search for solutions among learned and unlearned alternatives.</li>
                                <li>Troubleshot, collected, compiled, and analyzed information to develop recommendations</li>
                                <li>Tracked of parts inventory and prepare timely and accurate parts requisitions</li>
                            </ul>
                        </div>
                    )
                })
                break;
            case 5:
                setExperienceComponent(() => {
                    return (
                        <div className={innerContainerClass}>
                            <h2>Senior A/V Technician</h2>
                            <p><i>Berea College</i> • PTE • Aug 2014 - May 2018</p>
                            <ul>
                                <li>Lead team of A/V technicians in recording events hosted by the Department of Music. </li>
                                <li>Trained new employees on video equipment, sound systems, and post production</li>
                                <li>Developed and maintain good rapport among faculty and staff to encourage good communication between departments</li>
                                <li>Lead event setup and strike</li>
                                <li>Maintained working knowledge of all available equipment</li>
                                <li>Scheduled live events, lead sound checks, and set lighting cues for shows</li>
                                <li>Increased work efficiency of team and POST computers: decreased event production time by over 8 hours, allowing for events to be processed within one day</li>
                            </ul>
                        </div>
                    )
                })
                break;
            default:
                // setShowExperienceComponent(false)
                break;
        }
    }
                    
    function Education() {
        return (
            <div className={containerClass}>
                <div className="education-info">
                    <h2>Computer Science</h2>
                    <p><i>Berea College</i> • May 2018</p>
                    <p>
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/CSC-Computer-Science/100/CSC-110">CSC 110 Craft of Computing</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/CSC-Computer-Science/100/CSC-124">CSC 124 Building Better Apps</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/CSC-Computer-Science/200/CSC-226">CSC 226 Software Design and Implementation</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/CSC-Computer-Science/200/CSC-236">CSC 236 Data Structures</a>, 
                        <a target="_blank" href="https://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/ETAD-Engr-Tech-Applied-Design/200/ETAD-265">TAD 265 Electricity and Electronics</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/CSC-Computer-Science/300/CSC-303">CSC 303 Theory of Computation</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/CSC-Computer-Science/300/CSC-335">CSC 335 Computer Organization</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/CSC-Computer-Science/400/CSC-426">CSC 426 Open Source Software Engineering</a>
                    </p>
                    <h2>Music: Performance</h2>
                    <p><i>Berea College</i> • May 2018</p>
                    <p>
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/100/MUS-100">MUS 100 Class Piano</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/100/MUS-101">MUS 101 Class Piano II</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/100/MUS-115">MUS 115 Intro to Music Literature</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/100/MUS-128S">MUS 128S The Complete Performer</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/100/MUS-130A">MUS 130A Chamber Singers</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/100/MUS-130B">MUS 130B Jazz Ensemble</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/100/MUS-130E">MUS 130E Chamber Music</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/100/MUS-130G">MUS 130G Chamber Winds</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/100/MUS-131">MUS 131 Concert Choir</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/100/MUS-132">MUS 132 Wind Ensemble</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/200/MUS-220">MUS 220 Materials of Music I</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/200/MUS-221">MUS 221 Aural Harmony I</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/200/MUS-222">MUS 222 Materials of Music II</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/200/MUS-223">MUS 223 Aural Harmony II</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/300/MUS-320">MUS 320 Materials of Music III</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/300/MUS-321">MUS 321 Aural & Keyboard Harmony III</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/300/MUS-322">MUS 322 Materials of Music IV</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/300/MUS-323">MUS 323 Aural & Keyboard Harmony IV</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/300/MUS-330">MUS 330 Music History I</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/300/MUS-331">MUS 331 Music History II</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/300/MUS-340P">MUS 340P Piano Pedagogy</a>, 
                        <a target="_blank" href="http://berea.smartcatalogiq.com/Current/Catalog/Course-Descriptions/MUS-Music/400/MUS-400">MUS 400 Senior Seminar</a>
                    </p>
                </div>
            </div>
        )
    }

    function Experience() {
        return(
            <div className="experience-buttons">
                <button tabIndex={1} onClick={() => handleExperienceButtons(0)}>Prescient</button>
                <button tabIndex={1} onClick={() => handleExperienceButtons(1)}>Channel One</button>
                <button tabIndex={1} onClick={() => handleExperienceButtons(2)}>ITGuys</button>
                <button tabIndex={1} onClick={() => handleExperienceButtons(3)}>Sunrun</button>
                <button tabIndex={1} onClick={() => handleExperienceButtons(4)}>Gameworks</button>
                <button tabIndex={1} onClick={() => handleExperienceButtons(5)}>Berea College</button>
            </div>
        )
    }

    function Expertise() {
        return (
            <div className={containerClass}>
                <div className="skill-info">
                    <div>
                        <h2>Frontend development</h2>
                        <div className="skill-bars">
                            <p>React</p>
                            <div className="skill-container">
                                <div className="bar react-skill animate-skill">60%</div>
                            </div>
                            <p>CSS</p>
                            <div className="skill-container">
                                <div className="bar css-skill animate-skill">80%</div>
                            </div>
                            <p>Javascript</p>
                            <div className="skill-container">
                                <div className="bar js-skill animate-skill">80%</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h2>Frontend Builders</h2>
                        <div className="skill-bars">
                            <p>Wordpress</p>
                            <div className="skill-container">
                                <div className="bar wordpress-skill animate-skill">50%</div>
                            </div>
                            <p>Elementor</p>
                            <div className="skill-container">
                                <div className="bar elementor-skill animate-skill">90%</div>
                            </div>
                            <p>Divi</p>
                            <div className="skill-container">
                                <div className="bar divi-skill animate-skill">70%</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h2>IT Automation</h2>
                        <div className="skill-bars">
                            <p>Powershell</p>
                            <div className="skill-container">
                                <div className="bar powershell-skill animate-skill">70%</div>
                            </div>
                            <p>Python</p>
                            <div className="skill-container">
                                <div className="bar python-skill animate-skill">60%</div>
                            </div>
                            <p>Zapier</p>
                            <div className="skill-container">
                                <div className="bar zapier-skill animate-skill">90%</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    
    return (
        <div className="resume">
            <div className="resume-header-buttons">
                <a tabIndex={1} onClick={() => handleClick(<Education />, "resume-container")}>Education</a>
                <a tabIndex={1} onClick={() => handleClick(<Experience />, "resume-container")}>Experience</a>
                <a tabIndex={1} onClick={() => handleClick(<Expertise />, "resume-container")}>Expertise</a>
            </div>
            {currentComponent}
            {showExperienceComponent && experienceComponent}
        </div>
    )
}